import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  Tabs,
  TabList,
  Tab,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { FixedIncomeProducts } from './components/FixedIncomeProducts';
import { GovernmentBondProducts } from './components/GovernmentBondProducts';
import { FundsProducts } from './components/FundsProducts';
import { ProductDetails } from './components/ProductDetails';
import { ConfirmExitModal } from './components/ConfirmExitModal';

import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';
import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';

enum EProductsTabsIndexes {
  FixedIncome = 0,
  GovernmentBond = 1,
  Funds = 2
}

interface Props {
  isLoadingButtonOnDetail: boolean;
  products: IProductGetLastState[];
  closeModal?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Products',
  props: {
    isLoadingButtonOnDetail: { type: Boolean },
    products: null,
    closeModal: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isLoadingButtonOnDetail: boolean;
  products: IProductGetLastState[];
  closeModal?: boolean;
}



const stepComponent = {
  [EProductsTabsIndexes.FixedIncome]: FixedIncomeProducts,
  [EProductsTabsIndexes.Funds]: FundsProducts,
  [EProductsTabsIndexes.GovernmentBond]: GovernmentBondProducts
};

const router = useRouter();
const route = useRoute();

const currentTabIndex = ref(EProductsTabsIndexes.FixedIncome);
const selectedProductId = ref('');
const isConfirmModalOpen = ref(false);

const tabs = [
  {
    label: 'Renda fixa',
    icon: 'BA0011'
  },
  {
    label: 'Tesouro direto',
    icon: 'CA0100'
  },
  {
    label: 'Fundos',
    icon: 'EF0110'
  }
];

const step = computed(() => {
  return {
    component: stepComponent[currentTabIndex.value]
  };
});

const canAddProduct = computed(() =>
  Boolean(
    !props.products.find(
      product => product.productId === selectedProductId.value
    )
  )
);

function onChangeTab(tab: EProductsTabsIndexes) {
  const type: { [key: number]: string } = {
    0: 'fixed-income',
    1: 'government-bond',
    2: 'funds'
  };

  WarrenSession.set(StorageKeys.ProductCatalogType, type[tab], true);

  currentTabIndex.value = tab;
}

function goBack() {
  const cameFrom = (route.query?.module as string) || 'catalog';

  router.push({ name: cameFrom });
}

watch(
  () => props.closeModal,
  closeModal => {
    if (closeModal) {
      selectedProductId.value = '';
    }
  },
  { immediate: true }
);

onBeforeMount(() => {
  const tabIndexType: { [key: string]: EProductsTabsIndexes } = {
    'fixed-income': EProductsTabsIndexes.FixedIncome,
    'government-bond': EProductsTabsIndexes.GovernmentBond,
    funds: EProductsTabsIndexes.Funds
  };

  const type =
    WarrenSession.get(StorageKeys.ProductCatalogType) || 'fixed-income';
  currentTabIndex.value = tabIndexType[type];
});

return { __sfc: true,EProductsTabsIndexes, props, stepComponent, router, route, currentTabIndex, selectedProductId, isConfirmModalOpen, tabs, step, canAddProduct, onChangeTab, goBack, NavBar, Tabs, TabList, Tab, InitialAvatarIcon, BackButton, ProductDetails, ConfirmExitModal }
}

})